import { memo } from 'react'
import { Stack } from 'components'
import { ScrollArea } from '@mantine/core'
import { useBrowseTree } from './context/BrowseTreeContext'
import { isLvl4Item } from './types'
import { BrowseTreeNavigationItem } from './BrowseTreeNavigationItem'
import { BrowseTreeSelectableItem } from './BrowseTreeSelectableItem'
import { BrowseTreeEmptyState } from './BrowseTreeEmptyState'

export const BrowseTreeList = memo(() => {
  const {
    currentItems,
    currentLevel,
    isDataReady,
    pendingIds,
    alreadyAddedIds,
    navigateForward,
    onToggle,
    getSelectionCount,
  } = useBrowseTree()

  if (!isDataReady) {
    return <BrowseTreeEmptyState isLoading />
  }

  if (currentItems.length === 0) {
    return <BrowseTreeEmptyState />
  }

  const isLeafLevel = currentLevel === 4

  return (
    <ScrollArea
      style={{ height: '100%' }}
      offsetScrollbars
      scrollbarSize={6}
    >
      <Stack spacing={12} px={24} py={16}>
        {isLeafLevel ? (
          currentItems.filter(isLvl4Item).map(item => (
            <BrowseTreeSelectableItem
              key={item.id}
              item={item}
              isSelected={pendingIds.has(item.id)}
              isAlreadyAdded={alreadyAddedIds.has(item.id)}
              onToggle={onToggle}
            />
          ))
        ) : (
          currentItems.map(item => (
            <BrowseTreeNavigationItem
              key={item.id}
              item={item}
              count={getSelectionCount(item.id)}
              onClick={navigateForward}
            />
          ))
        )}
      </Stack>
    </ScrollArea>
  )
})

BrowseTreeList.displayName = 'BrowseTreeList'
